import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IResponseIdName } from '../globalQuery';

interface IPaginationParams {
  currentPage?: number;
  itemPerPage?: number;
  inputSearch?: string;
  selectiveProcess?: string;
  refetchOnMount?: boolean;
  id?: string;
  remove_pagination?: boolean;
  step_id?: string;
  registrationId?: string;
}

export interface ITitleResourceList {
  id: string;
  name: string;
  items: IResponseIdName[];
}

const GetResourceTitleList = async (params?: IPaginationParams) => {
  const response = await configApi.get<ITitleResourceList[]>(`api/title-submissions/categories-by-registration-step/`, {
    params: {
      registration: params?.registrationId,
    },
  });
  return response.data;
};

export const useGetResourceTitleList = (params?: IPaginationParams) => {
  return useQuery({
    queryKey: ['get_resource_title_list', params],
    queryFn: () => GetResourceTitleList(params),
    refetchOnWindowFocus: false,
    enabled: !!params?.registrationId,
    gcTime: 0,
  });
};
